import setSearchedLocationAndNavigateToResults from '@location/actions/setSearchedLocationAndNavigateToResults';
import resetOutOfDeliveryError from '@core/reducers/cart/actions/resetOutOfDeliveryError';

const navigateToShopsListAfterOutOfDelivery = location => dispatch => {
  dispatch(resetOutOfDeliveryError());
  dispatch(setSearchedLocationAndNavigateToResults(location));
};

export default navigateToShopsListAfterOutOfDelivery;
